import { ThemeEvents } from '@theme/events';

/**
 * Custom element that handles variant usage display updates
 */
class VariantUsageBlock {
  constructor() {
    this.blocks = document.querySelectorAll('[data-variant-usage]');
    this.init();
  }

  init() {
    if (this.blocks.length === 0) return;
    
    document.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate.bind(this));
  }

  handleVariantUpdate(event) {
    const { resource: variant, data } = event.detail;
    
    if (!variant) return;

    this.blocks.forEach(block => {
      this.updateUsageDisplay(block, variant);
    });
  }

  updateUsageDisplay(block, variant) {

    const usageTextElement = block.querySelector('[data-usage-text]');
    const contentElement = block.querySelector('.variant-usage-content');
    
    if (!usageTextElement || !contentElement) return;

    const usageText = window.variantMetafields[variant.id]    
  
    if (usageText && usageText.trim() !== '') {
      usageTextElement.textContent = usageText;
      block.removeAttribute('hidden');
    } else {
      block.setAttribute('hidden', '');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantUsageBlock());
} else {
  new VariantUsageBlock();
}
